import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import {
  PoPageLogin,
  PoPageLoginLiterals,
  PoPageLoginModule,
  PoPageLoginRecovery,
  PoModalPasswordRecoveryType,
  PoModalPasswordRecovery,
  PoModalPasswordRecoveryComponent,
  PoModalPasswordRecoveryModule
} from '@po-ui/ng-templates';
import { PoNotificationService } from '@po-ui/ng-components';

import { LoginService } from '../../core/services/login.service';
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, PoPageLoginModule, PoModalPasswordRecoveryModule],
  templateUrl: './login.html',
  styleUrls: ['./login.css']
})
export class LoginComponent implements OnInit {

  @ViewChild(PoModalPasswordRecoveryComponent, { static: true })
  poModalPasswordRecovery!: PoModalPasswordRecoveryComponent;

  buttonLoading = false;

  readonly recoveryType = PoModalPasswordRecoveryType.Email;

  readonly logoUrl$: Observable<string>;
  //readonly secondaryLogoUrl$: Observable<string>;

  readonly loginLiterals: PoPageLoginLiterals = {
    welcome: 'Bem-vindo ao GNF - Gestão de Notas Fiscais',
    loginHint: 'Informe seu e-mail corporativo.',
    loginLabel: 'E-mail',
    loginPlaceholder: 'Digite seu e-mail',
    passwordLabel: 'Senha',
    passwordPlaceholder: 'Digite sua senha',
    forgotPassword: 'Esqueci minha senha',
    submitLabel: 'Entrar',
    submittedLabel: 'Entrando...',
    loginErrorPattern: 'E-mail invalido.',
    passwordErrorPattern: 'Senha invalida.'
  };

  passwordRecovery: PoPageLoginRecovery = {
    url: 'portalnf/auth/sendreset',
    type: PoModalPasswordRecoveryType.Email
  };

  constructor(
    public router: Router,
    private loginService: LoginService,
    private themeService: ThemeService,
    private poNotification: PoNotificationService
  ) {
    this.logoUrl$ = this.themeService.logo$;
    //this.secondaryLogoUrl$ = this.themeService.secondaryLogo$;
  }

  ngOnInit(): void {
    this.loginService.logout(false);
  }

  openPasswordRecoveryModal(): void {
    this.poModalPasswordRecovery?.open();
  }

  submitRestorPass(event: PoModalPasswordRecovery): void {
    this.loginService.sendMailRecovery({ email: event.email! }).pipe(take(1)).subscribe({
      next: () => {
        this.poModalPasswordRecovery.completed();
        this.poNotification.success({
          message: 'Se o e-mail estiver cadastrado, voce recebera um link de redefinicao.'
        });
      },
      error: () => {
        this.poNotification.error({
          message: 'Nao foi possivel enviar o e-mail de recuperacao. Tente novamente em instantes.'
        });
      }
    });
  }

  loginSubmit(formData: PoPageLogin): void {
    this.buttonLoading = true;
    this.loginService.login(formData.login!, formData.password!).pipe(take(1)).subscribe({
      next: () => {
        this.buttonLoading = false;
        this.router.navigate(['/notas-list']);
      },
      error: (err: HttpErrorResponse | string) => {
        this.buttonLoading = false;
        this.poNotification.error({ message: this.buildLoginErrorMessage(err) });
      }
    });
  }

  private buildLoginErrorMessage(err: HttpErrorResponse | string | unknown): string {
    if (typeof err === 'string' && err.length > 0) {
      return err;
    }
    const httpErr = err as HttpErrorResponse;
    const status = httpErr?.status;
    const backendMsg = httpErr?.error?.message;

    if (status === 401) {
      return backendMsg || 'E-mail ou senha invalidos. Verifique os dados e tente novamente.';
    }
    if (status === 0) {
      return 'Nao foi possivel conectar ao servidor. Verifique sua conexao.';
    }
    if (status === 423 || status === 403) {
      return backendMsg || 'Acesso bloqueado. Entre em contato com o administrador.';
    }
    return backendMsg || 'Nao foi possivel realizar o login. Tente novamente.';
  }
}
